import { useState } from "react";
import { useOutletContext, useSearchParams } from "react-router-dom";
import {
  Tabs,
  TabsList,
  TabsTrigger,
  TabsContent,
} from "@/components/ui/tabs";
import ScheduleSheet from "@/pages/ScheduleSheet";
import CheckIn from "@/pages/CheckIn";

export default function Schedule() {
  const ctx = useOutletContext();
  const [params, setParams] = useSearchParams();
  const initial = params.get("tab") === "checkin" ? "checkin" : "sheet";
  const [tab, setTab] = useState(initial);

  function onChange(v) {
    setTab(v);
    setParams((p) => {
      const np = new URLSearchParams(p);
      np.set("tab", v);
      return np;
    });
  }

  return (
    <Tabs value={tab} onValueChange={onChange} className="space-y-6">
      <TabsList
        data-testid="schedule-tabs"
        className="bg-zinc-100 print:hidden"
      >
        <TabsTrigger value="sheet" data-testid="schedule-tab-sheet">
          Schedule Sheet
        </TabsTrigger>
        <TabsTrigger value="checkin" data-testid="schedule-tab-checkin">
          Check-in
        </TabsTrigger>
      </TabsList>
      <TabsContent value="sheet" className="mt-0">
        <ScheduleSheet />
      </TabsContent>
      <TabsContent value="checkin" className="mt-0">
        {ctx?.status?.configured ? (
          <CheckIn />
        ) : (
          <div className="p-12 rounded-lg border-2 border-dashed border-zinc-200 bg-zinc-50 text-center text-sm text-zinc-600">
            Connect Acuity in Settings to use bulk check-in.
          </div>
        )}
      </TabsContent>
    </Tabs>
  );
}
